var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutDayLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 60,
  viewBox: "0 0 80 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M76 0a4 4 0 0 1 4 4v52a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 4H4v52h72v-8.001L70 48a2 2 0 0 1-2-2V18a2 2 0 0 1 2-2l6-.001zM34 16a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V18a2 2 0 0 1 2-2zm28 0a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H42a2 2 0 0 1-2-2V18a2 2 0 0 1 2-2zM46 8a2 2 0 1 1 0 4H34a2 2 0 1 1 0-4z"
})));
export default SvgLayoutDayLg;